import React, { useCallback, useEffect, useRef, useState } from 'react'
import DualListBox from 'react-dual-listbox'
import 'react-dual-listbox/lib/react-dual-listbox.css'
import { useGetGoldProductDetail } from '../../../services/sell/sell-query'
import { Box, CircularProgress } from '@material-ui/core'
import styled from '@emotion/styled'

export const CustomStyledDualListBox = styled(DualListBox)`
  & .rdl-control {
    overflow-x: auto;
  }
`

type Props = {
  selectedProducts?: string[]
  categoryName?: string
}

const SelectedProduct = (props: Props) => {
  const { selectedProducts = [], categoryName } = props

  const { mutateAsync: getGoldProductDetail, isLoading } = useGetGoldProductDetail()

  const [selectedOptions, setSelectedOptions] = useState<{ label: string; value: string }[]>([])
  const [isFetched, setIsFetched] = useState(false)

  const fetchSelectedOptions = useCallback(async () => {
    const options: { label: string; value: string }[] = []

    const product = await getGoldProductDetail({
      tag: categoryName,
      sortWeight: 'ASC',
      sortMintingCost: 'ASC',
      inStock: 'Y',
    })
    if (!product) return

    product.forEach(item => {
      const option = {
        label: `${item.cardName} - ${item.name} - ${item.brand}`,
        value: String(item.id),
      }
      options.push(option)
    })

    setSelectedOptions(options)
    setIsFetched(true)
  }, [categoryName, getGoldProductDetail])

  useEffect(() => {
    if (isFetched || selectedProducts.length < 1) return
    fetchSelectedOptions()
  }, [fetchSelectedOptions, isFetched, selectedProducts.length])

  return (
    <div style={{ width: '1000px', minHeight: '200px' }}>
      {isLoading ? (
        <Box style={{ display: 'flex', padding: 16, justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <div>
          <CustomStyledDualListBox
            options={selectedOptions}
            selected={selectedProducts}
            disabled
            preserveSelectOrder
            canFilter={true}
            filterCallback={(option: any, filterInput) =>
              option?.label?.toLowerCase().includes(filterInput?.toLowerCase()) ||
              (option?.value && option?.value?.includes(filterInput?.toLowerCase()))
            }
          />
        </div>
      )}
    </div>
  )
}

export default SelectedProduct
